import React from 'react';
import './Modals.scss';

const ErrorMessageModal = ({message}) => (
  <div class='cb-modal cb-dialog-modal' id='errorMessageModal' aria-hidden='true' data-cb-apricot='modal-dialog'>
    <div class='cb-modal-overlay' tabIndex='-1'>
      <div class='cb-modal-container' role='alertdialog' aria-modal='true' aria-labelledby=''>
        <div class='cb-modal-content'>
          <div class='cb-dialog cb-dialog-dismissible cb-dialog-error' role='alert' aria-labelledby='errorMessageModalTitle'>
            <div class='cb-dialog-container'>
              <div class='cb-dialog-header'>
                <span class='cb-icon cb-icon-circular cb-exclamation cb-red1-color' aria-hidden='true' />
                <h4 class='cb-dialog-title' id='errorMessageModalTitle'> Error </h4>
                <button type='button' class='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close' aria-describedby='errorMessageModalTitle' data-cb-modal-close>
                  <span class='cb-icon cb-x-mark' aria-hidden='true' />
                  <span class='sr-only'>Close</span>
                </button>
              </div>
              <div class='cb-dialog-content'>
                {message}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

);

export default ErrorMessageModal;